<template>
  <span
    v-if="
      extraData instanceof
        require('../../../store/classes/SharedPeriods').default
    "
  >
    <el-dropdown size="mini">
      <span class="el-dropdown-link"
        >{{ value }} <i class="el-icon-arrow-down el-icon--right"></i
      ></span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          v-for="(p, i) in extraData.periods"
          :key="i"
          :icon="'el-icon-' + p.statusFromNow"
          >{{ p.asString }}</el-dropdown-item
        >
      </el-dropdown-menu>
    </el-dropdown>
    <span
      v-if="extraData.actualPeriod"
      v-text="extraData.actualPeriod.endingFromNow"
      style="margin-left: 20px"
    />
  </span>
  <span v-else v-text="value" />
</template>
<script>
export default {
  name: "extraElement",
  props: ["extraData", "value"]
};
</script>

<style scoped></style>
